import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getBGfromVariant } from "../functions";
import { useContentfulPage } from "../context/ContentfulPageContext";
import { StyleManagementFab } from "../styling/StyleManagement";
const ROOT_SECTION_STYLES = "py-[80px] px-[16px] lg:py-[128px] ";
const NESTED_SECTION = "py-[40px] px-[8px] lg:py-[64px]";
export const PageSectionWrapper = ({ variant = "normal", isNested = false, parsedClasses = "", children, sectionId = "", }) => {
    const { isPreview, getContentBlockStyles, previewStyles } = useContentfulPage();
    const savedStyles = getContentBlockStyles(sectionId);
    // Use preview styles if available for this block, otherwise use saved styles
    const blockStyles = ((previewStyles === null || previewStyles === void 0 ? void 0 : previewStyles.blockId) === sectionId ? previewStyles.styles : savedStyles) || {};
    const backgroundColor = (blockStyles === null || blockStyles === void 0 ? void 0 : blockStyles.backgroundColor) || getBGfromVariant(variant);
    const previewStylesClass = isPreview ? "hover:ring-[5px] hover:ring-inset hover:ring-orange-500 group" : "";
    const pageSectionStyles = getPageSectionStyles(blockStyles === null || blockStyles === void 0 ? void 0 : blockStyles.wrapperType, isNested, blockStyles);
    return (_jsxs("section", { className: `${backgroundColor} ${pageSectionStyles.outerWrapper || ""} ${previewStylesClass} ${parsedClasses !== null && parsedClasses !== void 0 ? parsedClasses : ""}`, children: [isPreview && sectionId.length > 0 && _jsx(StyleManagementFab, { sectionId: sectionId, isNested: isNested }), _jsx("div", { className: pageSectionStyles.innerWrapper, children: children })] }));
};
const getPageSectionStyles = (wrapperType, isNested, blockStyles) => {
    switch (wrapperType) {
        case "page_header":
            return {
                innerWrapper: "mt-8 lg:flex-row flex-wrap w-[100%] p-0 h-[550px] max-w-[1124px] m-auto",
                outerWrapper: `relative px-0 lg:rounded-br-[100px] overflow-hidden`,
            };
        case "page_section":
        default:
            return {
                innerWrapper: "relative flex flex-col max-w-[1124px] w-full",
                outerWrapper: `relative flex justify-center text-center md:text-left flex-col md:flex-row ${(blockStyles === null || blockStyles === void 0 ? void 0 : blockStyles.sectionPadding) || (isNested && NESTED_SECTION) || ROOT_SECTION_STYLES}`,
            };
    }
};
